import { useContext, useEffect, useState } from 'react';

// Hooks
import useAbortController from '../../../../packages/hooks/useAbortController';

// Contexts
import TennisApiContext from '../contexts/TennisApiContext';

// Types
import { ITennisTournament, ITennisTournamentsResponseData } from '../../../../packages/types';

interface IUseTennisTournamentsArgs {
  playerId?: string;
  competitionId?: string;
}

export default function useTournaments({ playerId, competitionId }: IUseTennisTournamentsArgs) {
  const { $tennis } = useContext(TennisApiContext);
  const [tournaments, setTournament] = useState<ITennisTournament[]>([]);
  const [getSignal] = useAbortController();

  useEffect(() => {
    const signal = getSignal();
    $tennis
      ?.getTournaments({ playerId, competitionId, signal })
      ?.then(({ tournaments }: ITennisTournamentsResponseData) => {
        setTournament(tournaments);
      })
      .catch((error: unknown) => {
        console.error(error);
      });
  }, [$tennis, playerId, competitionId, getSignal]);

  return {
    tournaments,
  };
}
